import dayjs from "dayjs";
import { analyticsTheme } from "../../components/analytics/analyticsTheme";

/** Batch metrics are typed `number | string` (BE default 0) — coerce safely. */
export const toNumber = (
  value: number | string | null | undefined
): number | null => {
  if (value == null) return null;
  const n = typeof value === "string" ? Number(value) : value;
  return Number.isNaN(n) ? null : n;
};

// Shared colour scale for percentage bars (read depth, video completion):
// green when high, amber mid, red low. Mirrors the mockup (87% green, 64%/42%
// amber).
export const depthColor = (pct: number): string => {
  if (pct >= 70) return analyticsTheme.metricSuccess;
  if (pct >= 40) return analyticsTheme.metricOrange;
  return analyticsTheme.metricError;
};

// `first_seen_date` / `last_seen_date` are day-granularity (no time component),
// so `fromNow()` would count hours from midnight ("12 hours ago" for a session
// earlier today). Compare calendar days instead: Today, Yesterday, else "N days
// ago". No `addDateTz` here — that helper marks datetimes as UTC, but a bare
// date has no time to convert.
export const formatSeenDay = (
  date: string | null | undefined,
  t: (key: string) => string
): string => {
  if (!date) return "—";
  const day = dayjs(date).startOf("day");
  const diffDays = dayjs().startOf("day").diff(day, "day");
  if (diffDays <= 0) return t("media.analytics.relativeDay.today");
  if (diffDays === 1) return t("media.analytics.relativeDay.yesterday");
  return day.fromNow();
};
